import { createFileRoute } from "@tanstack/react-router";

import { RouteErrorFallback } from "@/components/error-message";
import { AdminPending } from "@/features/admin/components/admin-route-components";
import { adminDomainsQueryOptions } from "@/features/admin/lib/domains-queries";
import { adminSeoHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/_authenticated/admin/domains")({
  head: () => adminSeoHead("Domains"),
  loader: ({ context }) =>
    context.queryClient.query({ ...adminDomainsQueryOptions, staleTime: "static" }),
  pendingComponent: AdminPending,
  errorComponent: RouteErrorFallback,
});
